module.exports = __webpack_public_path__ + "media/images/top/intro-logo-b9285cd6d0fb2827a2f2fb6040b8c3c2.png";